// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.ordertypes.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/ordertypes/ordertype/ordertype.tpl.html',
            controller: 'OrderTypeController as vm'
        }},
        resolve: {
            ordertype: function() { return {}; },
            printDocumentTemplates: printDocumentResolver,
            deliveryPlanningTemplate: deliveryPlanningTemplatesResolver,
            locations: locationsResolver,
            languages: languagesResolver,
            isNewOrderType: function() {return true;}
        }
    });

    $stateProvider.state('base.ordertypes.ordertype', {
        url:'/{ordertypeId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/ordertypes/ordertype/ordertype.tpl.html',
            controller: 'OrderTypeController as vm'
        }},
        resolve: {
            ordertype: ordertypeResolver,
            printDocumentTemplates: printDocumentResolver,
            deliveryPlanningTemplate: deliveryPlanningTemplatesResolver,
            locations: locationsResolver,
            languages: languagesResolver,
            isNewOrderType: function() {return false;}
        }
    });

}

// @ngInject
function ordertypeResolver($stateParams, OrderTypesApiService) {
    return OrderTypesApiService.getOrderType($stateParams.ordertypeId);
}

// @ngInject
function printDocumentResolver($stateParams, OrderTypesApiService) {
    return OrderTypesApiService.getPrintDocumentTemplates();
}
// @ngInject
function deliveryPlanningTemplatesResolver($stateParams, OrderTypesApiService) {
    return OrderTypesApiService.getDeliveryPlanningTemplates();
    
}

// @ngInject
function languagesResolver($stateParams, OrderTypesApiService) {
    return OrderTypesApiService.getLanguages();
}

// @ngInject
function locationsResolver(OrderTypesApiService) {
    return OrderTypesApiService.getLocations();
}


// @ngInject
function OrderTypeController($state, ordertype, deliveryPlanningTemplate ,printDocumentTemplates, loadSpinnerService, OrderTypesApiService, OrdersApiService, ToasterService, confirmationDialogService, $translate, isNewOrderType, languages, locations) {
    var vm = this;

    var ordertypeCopy = {};
    vm.enableDeliveryPlanning = false;

    vm.ordertype = ordertype;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveOrderType = saveOrderType;
    vm.deleteOrderType = deleteOrderType;
    vm.deliveryPlanningTemplate;
    vm.isNewOrderType = isNewOrderType;
    vm.isEditing = vm.isNewOrderType;

    vm.printDocumentTemplates = printDocumentTemplates;
    vm.getDeliveryPlanningTemplates =  deliveryPlanningTemplate;

    vm.isAllInformationValid = isAllInformationValid;
    vm.languages = languages;

    vm.toggleDisplayForm = toggleDisplayForm;
    vm.locations = locations;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewOrderType) {
            vm.ordertype = {};
        }

        appendLocalizations(vm.ordertype, vm.languages);
        appendLocations(vm.locations);
        initDeliveryPlanningTemplate();
        isDeliveryPlanningEnabled();
    }

    function isDeliveryPlanningEnabled() {
        OrdersApiService.isDeliveryPlanningEnabled().then(function(response){
            vm.enableDeliveryPlanning = response;
        }, function(error){
            ToasterService.showError(error.message);
        });
    }

    function initDeliveryPlanningTemplate(){
       vm.deliveryPlanningTemplate = vm.ordertype.deliveryPlanningTemplate;
    }
    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function appendLocations(locations) {
        locations.push({ id: 0, locationName: '-'});
    }

    function enableEditing() {
        ordertypeCopy = angular.copy(vm.ordertype);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.ordertype = ordertypeCopy;
        vm.isEditing = false;
    }

    function saveOrderType() {
        if (vm.isNewOrderType) {
            saveNewOrderType();
        } else {
            updateOrderType();
        }
    }

    function saveNewOrderType() {
        loadSpinnerService.start('mainSpinner');
        OrderTypesApiService.createOrderType(vm.ordertype).then(function(response) {
            vm.ordertype = response;
            prepareData();
            vm.isNewOrderType = false;
            vm.isEditing = false;
            $state.go('base.ordertypes.ordertype', {ordertypeId: vm.ordertype.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateOrderType() {
        loadSpinnerService.start('mainSpinner');
        if(vm.enableDeliveryPlanning){
            if(vm.deliveryPlanningTemplate.id <= 0 || vm.deliveryPlanningTemplate.id === undefined){ 
                vm.deliveryPlanningTemplate.id = null;
            }
            vm.ordertype.deliveryPlanningTemplateId = vm.deliveryPlanningTemplate.id;
        }
        else {
            vm.ordertype.deliveryPlanningTemplateId = null;
        }
        OrderTypesApiService.updateOrderType(vm.ordertype).then(function(response) {
            vm.ordertype = response;
            prepareData();
            vm.isNewOrderType = false;
            vm.isEditing = false;
            $state.go('base.ordertypes.ordertype', {ordertypeId: vm.ordertype.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteOrderType() {
        confirmationDialogService
            .showDialog($translate.instant('ordertype.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    OrderTypesApiService.deleteOrderType(vm.ordertype.id).then(function(response) {
                        vm.ordertype = response;
                        prepareData();
                        vm.isNewOrderType = false;
                        vm.isEditing = false;
                        $state.go('base.ordertypes');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(ordertype) {
        ordertype.showEditForm = !ordertype.showEditForm;
    }

    function prepareData() {
        if (vm.ordertype === undefined) {
            return;
        }

        vm.ordertypeCopy = angular.copy(vm.ordertype);
    }

    function isAllInformationValid() {
        return true;
    }


    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('ordertypes.ordertype', [])
    .config(stateConfig)
    .controller('OrderTypeController', OrderTypeController);
